/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserState } from '../state/user-state';
import { NotificationHubService } from '../core/services/notificationHub.service';
import { PreloaderService } from '../core/services/preloader.service';
import { Router, NavigationStart } from '@angular/router';
import { DialogService } from '../core/services/dialog.service';
import { Subject, take, takeUntil } from 'rxjs';
import { HeaderService } from '../core/services/header.service';
import { selectClientId } from '../state/reducer/user.reducer';
@Component({
  selector: 'app-dashboard',
  styleUrls: ['./default-layout.component.scss'],
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  clientId: string | undefined;

  constructor(
    private userStore: Store<UserState>,
    private notificationHubService: NotificationHubService,
    private dialogService: DialogService,
    private router: Router,
    protected preloaderService: PreloaderService,
    protected headerService: HeaderService
  ) {
    this.notificationHubService.connectToSignalR();
  }

  ngOnInit(): void {
    this.userStore
      .select(selectClientId)
      .pipe(take(1))
      .subscribe((clientId) => {
        this.clientId = clientId;
      });
    this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.dialogService.closeDialog();
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
